import React from 'react';
import styles from './ChannelsPanel.scss';
import classNames from 'classnames';
import type { ChannelType } from '@wix/ambassador-chat-channels-v1-channel/types';

export interface Channel {
  type: ChannelType;
  icon: JSX.Element;
  selectedIcon: JSX.Element;
}

export interface ChannelsPanelProps {
  channels: Channel[];
  onSelectedTab(type: ChannelType): void;
  selectedTab: ChannelType;
}

export const ChannelsPanel: React.FunctionComponent<ChannelsPanelProps> = ({
  channels,
  onSelectedTab,
  selectedTab,
}) => {
  return (
    <div className={styles.channelsPanel} data-hook="channels-panel">
      {Object.values(channels).map((tab) => (
        <div
          key={tab.type}
          className={classNames(styles.channel, {
            [styles.selected]: selectedTab === tab.type,
          })}
          onClick={() => onSelectedTab(tab.type)}
        >
          {tab.icon}
        </div>
      ))}
    </div>
  );
};
